<ng-container *ngIf="hasAsset">
  <img *ngIf="isImage" [src]="asset.url" [alt]="asset.fileName" />
  <video scanMediaAnalytics [attr.data-matomo-title]="asset.fileName" *ngIf="isVideo" controls>
    <source [src]="asset.url" [type]="asset.contentType" />
  </video>
</ng-container>
